import { delay, http, HttpResponse } from 'msw';
import type { LocalCommand } from './localApi';
import { calculateSection, validateProjectPoints } from './sectionEngine';
import { computePermissions, isViewerId } from './permissions';

export const commandHandler = http.post('/api/plan/navigation-projets/command', async ({ request }) => {
  const viewer = request.headers.get('X-Viewer');
  if (!isViewerId(viewer) || !computePermissions(viewer).canWrite) return HttpResponse.json({ error: '403 — Ce profil ne peut pas écrire ni calculer.' }, { status: 403 });
  try {
    const command = await request.json() as LocalCommand;
    validateProjectPoints(command.project.technicalPoints ?? []);
    if (!command.section) return HttpResponse.json(command.project);
    await delay(450);
    const plan = command.project.plans.find((p) => p.id === command.planId);
    if (!plan) throw new Error('Plan introuvable.');
    const calculated = calculateSection(command.project, plan, command.section, command.geo);
    return HttpResponse.json({
      ...command.project, plans: command.project.plans.map((p) => p.id === plan.id ? calculated : p),
    });
  } catch (error) {
    return HttpResponse.json({ error: error instanceof Error ? error.message : String(error) }, { status: 422 });
  }
});
